export default {
  $light: '#ffffffa6',
  $lightest: '#ffffff',
  $online: '#0e9347',
  $offline: '#4f4d4d',
  $warning: '#faad14',
  $darkest: '#000000',
  $errors: '#f52f39',
  $gray_background: '#1F1E1E'
};
